/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetTransferPeerResponseDataItemStatus = typeof GetTransferPeerResponseDataItemStatus[keyof typeof GetTransferPeerResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransferPeerResponseDataItemStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  REMOVED: 'REMOVED',
  EPHEMERAL: 'EPHEMERAL',
} as const;
